import React, { useState, useEffect } from "react";
import Table from "../../../core/pagination/datatable";
import { Link } from "react-router-dom";
// import dayjs from "dayjs";
import { getApiBaseUrl } from "../Config/Config";
import { Spin, Tag, Tooltip } from "antd";

const RoleNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);

  const handleMarkAsRead = async (record) => {
    try {
      await fetch(`${getApiBaseUrl()}/api/updatenotificationsIsRead`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: record.id }),
      });
      console.log(`Notification ${record.id} marked as read`);
    } catch (error) {
      console.error("Error marking notification as read:", error);
    } finally {
      fetchNotifications();
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "Message",
      dataIndex: "Message",
      key: "Message",
      sorter: (a, b) => a.Message?.localeCompare(b.Message),
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "30vw",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      dataIndex: "IsRead",
      key: "IsRead",
      render: (isread) =>
        isread === true ? (
          <Tag color="green">Read</Tag>
        ) : (
          <Tag color="red">Unread</Tag>
        ),
    },
    {
      title: "Date",
      dataIndex: "CreatedAt",
      key: "CreatedAt",
      // render: (text) => dayjs(text).format("DD/MM/YYYY HH:mm"),
      render: (text) => {
        if (!text) return "";
        const d = new Date(text);
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(d.getUTCDate())}/${pad(
          d.getUTCMonth() + 1
        )}/${d.getUTCFullYear()} ${pad(d.getUTCHours())}:${pad(
          d.getUTCMinutes()
        )}`;
      },
    },

    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div>
          <button
            className="btn btn-sm btn-success me-2"
            title="Mark as Read"
            disabled={record?.IsRead}
            onClick={() => handleMarkAsRead(record)}
          >
            <i className="fas fa-check"></i>
          </button>
          {/* <button
            className="btn btn-sm btn-danger"
            title="Send to Delete"
            // onClick={() => handleDelete(record)}
          >
            <i className="fas fa-times"></i>
          </button> */}
        </div>
      ),
    },
  ];

  const fetchNotifications = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    setNotificationsLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/getnotificationsToUser?UserID=${user?.UserID}`
      );
      const result = await response.json();
      if (result?.Status) {
        setNotifications(result.ResultData || []);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([]);
    } finally {
      setNotificationsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Notifications
                  </h4>
                </ol>
              </nav>
              <h6>Manage Your notifications</h6>
            </div>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set mt-4"></div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {notificationsLoading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : notifications.length > 0 ? (
                <Table dataSource={notifications} columns={columns} />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleNotifications;
